var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "progress-bars" },
    _vm._l(_vm.sliderCount, function (bullet, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass: "progress-bar",
          style: "width:" + _vm.width + "%",
        },
        [
          _c("div", {
            staticClass: "progress",
            class: { active: index == _vm.currentSlide },
          }),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }